export const ENDPOINTS_BOOK = {
  ARCHIVE_BOOK: '/bff-vle/userBooks/:userbookId/archive',
  BOOKS_ID: '/bk/books/:bookId',
  BOOKS_ID_MATERIALS: '/bff-vle/books/:bookId/materials',
  BOOKS_ID_MATERIALS_DEPRECATED: '/bk/books/:bookId/materials?email=:email',
  DEPRECATED_ME_USERBOOKS: '/bk/me/userBooks',
  DEPRECATED_STUDENTS_ID_USERBOOKS: '/bk/students/:targetId/userBooks',
  GET_ARCHIVED_BOOKS: '/bff-vle/me/userBooks/archived',
  LICENSES_ID_USER_ID: '/bff-vle/licenses/:licenseCode?userId=:userId',
  LICENSES_ID_USER_ID_ISO_COUNTRY:
    '/bff-vle/licenses/:licenseCode?userId=:userId&isoCountry=:isoCountry',
  ME_OLD_USERBOOS: '/bff-vle/me/oldUserBooks',
  ME_USERBOOKS: '/bff-vle/me/userBooks',
  ORDER_BOOKS: '/bff-vle/:userType/:userId/userBooks/reorder',
  STUDENTS_ID_USERBOOKS: '/bff-vle/students/:targetId/userBooks',
  TEACHERS_ID_USERBOOKS: '/bff-vle/teachers/:teacherId/userBooks',
  UNARCHIVE_BOOK: '/bff-vle/userBooks/:userbookId/unarchive',
}
